// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import pick from 'lodash/pick';
import logServiceSdkImplicitCreationDeprecation from './util/log-deprecation';
import ServiceSDKModule from './service-sdk';
import FeatureFlagSDKModule from './feature-flags-sdk';
/*
Return a FeatureFlagsSDK library instance.

config:
- applicationID: your FE app's unique application ID
- clientID: your FE app's unique client ID
- getCookies: (optional) Custom cookie access logic
- getCookieIdOverride: (optional) Custom cookie id access logic
- getBrowserSessionIdOverride: (optional) Custom browser id access logic
- getPageviewId: (optional) Custom hook to get current pageview id, used to
  set X-Pageview-ID header on requests
- getUrl: (optional) Custom hook to get current url, used to set
  X-Originating-Url header on requests
- uuid: (optional) Custom hook to get uuid
- featureFlagsBaseUrl: the feature flag base URL for your current environment.
*/

export default function (config) {
  var ServiceSDK = config.ServiceSDK;

  if (!ServiceSDK) {
    logServiceSdkImplicitCreationDeprecation();
    ServiceSDK = ServiceSDKModule(pick(config, ['applicationID', 'clientID', 'xhrTimeout', 'getCookies', 'getCookieIdOverride', 'getBrowserSessionIdOverride', 'getPageviewId', 'getUrl', 'uuid']));
  }

  return FeatureFlagSDKModule(ServiceSDK, pick(config, ['featureFlagsBaseUrl']));
}